import Vue from 'vue'
// import '@src/theme/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import {
  Pagination,
  Dialog,
  Autocomplete,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Scrollbar,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  DatePicker,
  TimePicker,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  Tree,
  Icon,
  Row,
  Col,
  Upload,
  Card,
  Collapse,
  CollapseItem,
  Loading,
  MessageBox,
  Message,
  Notification,
  Popover,
  Slider,
  Cascader,
} from 'element-ui'

const components = [
  Pagination,
  Dialog,
  Autocomplete,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Scrollbar,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  DatePicker,
  TimePicker,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  Tree,
  Icon,
  Row,
  Col,
  Upload,
  Card,
  Collapse,
  CollapseItem,
  Popover,
  Slider,
  Cascader,
]

components.forEach(component => Vue.use(component))

Vue.use(Loading.directive)

// message.js

// let messageStatus = null
// export default class ShowMessage {
//   success(options) {
//     this.message('success', options)
//   }

//   warning(options) {
//     this.message('warning', options)
//   }

//   info(options) {
//     this.message('info', options)
//   }

//   error(options) {
//     this.message('error', options)
//   }

//   message(type, options) {
//     if (messageStatus) {
//       messageStatus.close()
//     }
//     messageStatus = Message[type](options)
//   }
// }

Vue.prototype.$loading = Loading.service
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$notify = Notification
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message
// Vue.prototype.$message = new ShowMessage()
